// extracted by mini-css-extract-plugin
module.exports = {"LargeImage":"styles_LargeImage__Z5USa","image":"styles_image__tj5lm"};